import React, { useEffect } from 'react';
import {
  Routes, Route, BrowserRouter,
} from 'react-router-dom';

import styled from 'styled-components';

import PageNotFound from '@zimpel/common/components/PageNotFound';
import { navigateTo } from './common/helpers/browser';

import AppFooter from './AppFooter';

import Imprint from './microapps/StaticPages/Imprint';

import OptOut, { OPT_OUT_PATH, useIsOptOutPath } from './microapps/OptOut';
import PrivacyNotice from './microapps/StaticPages/PrivacyNotice';

import VerifyEmailPage from './microapps/VerifyEmailPage';

import Login from './microapps/Authentication/Login';
import PasswordReset from './microapps/Authentication/PasswordReset';
import PasswordNew from './microapps/Authentication/PasswordNew';
import ScrollToTop from './common/components/Layout/ScrollToTop';
import { ReloadWrapper } from './ReloadWrapper';
import { ModalProvider } from './common/components/Dialogue/Dialogue';
import LoggedOutAppHeader from './AppHeader/LoggedOutAppHeader';
import { AppContextContainer } from './AppContext';

const StyledLoggedOutContent = styled.div`
  width: var(--app-width);
  margin: 0 auto;
  min-height: calc(100vh - var(--app-header-height) - var(--footer-height));
`;

const RedirectToLoginPage: React.FC = () => {
  useEffect(() => {
    navigateTo('/login');
  });
  return null;
};

const LoggedOutLayout: React.FC<React.PropsWithChildren> = ({ children }) => (
  <>
    <LoggedOutAppHeader />
    <StyledLoggedOutContent>
      {children}
    </StyledLoggedOutContent>
    <AppFooter />
  </>
);

const Body = () => {
  const isOptOutPath = useIsOptOutPath();

  return isOptOutPath ? (
    <Routes>
      <Route path={OPT_OUT_PATH} element={<OptOut />} />
    </Routes>
  ) : (
    <LoggedOutLayout>
      <Routes>
        <Route path="/" element={<RedirectToLoginPage />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/privacy_notice" element={<PrivacyNotice />} />
        <Route path="/verify_email/:verificationCode" element={<VerifyEmailPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/password-new/:token" element={<PasswordNew />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </LoggedOutLayout>
  );
};

const LoggedOutApp: React.FC = () => (
  <AppContextContainer>
    <ModalProvider>
      <ReloadWrapper>
        <BrowserRouter>
          <ScrollToTop />
          <Body />
        </BrowserRouter>
      </ReloadWrapper>
    </ModalProvider>
  </AppContextContainer>
);

export default LoggedOutApp;
